import { Box } from '@mui/material'
import { isNoteBackedThreadId } from '@/features/notes/demo/notesRailDemoData'
import ThreadListRow from './ThreadListRow'
import styles from './BoardsSection.module.scss'

export function BoardsSectionPinnedList({ pinnedThreads, selectedThreadId, onSelectThread, onThreadMenuAction, onRenameThread }) {
  return (
    <Box className={styles.list}>
      {pinnedThreads.map((thread) => (
        <ThreadListRow
          key={thread.id}
          title={thread.title}
          thread={thread}
          menuSurface="boards"
          active={thread.id === selectedThreadId}
          showNoteIcon={isNoteBackedThreadId(thread.id)}
          onClick={() => onSelectThread?.(thread)}
          onThreadMenuAction={onThreadMenuAction}
          onRenameThread={onRenameThread}
        />
      ))}
    </Box>
  )
}
